const { axiosService } = require('service')
const { salesClientsEndpoints } = require('service/sources/sales/clients')

const exportClients = (body) => {
  return axiosService.post(salesClientsEndpoints.EXPORT_CLIENTS, body)
}
const exportProviders = (body) => {
  return axiosService.post(salesClientsEndpoints.EXPORT_PROVIDERS, body)
}

const clientsArca = (body) => {
  return axiosService.post(salesClientsEndpoints.CLIENTS_ARCA, body)
}

const clientsList = (options) => {
  return axiosService.get(salesClientsEndpoints.LIST + options)
}

const searchClients = (body) => {
  return axiosService.post(salesClientsEndpoints.SEARCH_CLIENTS, body)
}

const searchAutocompleteClients = (query) => {
  return axiosService.get(salesClientsEndpoints.SEARCH_AUTOCOMPLETE + query)
}

const create = (values) => {
  return axiosService.post(salesClientsEndpoints.CREATE_CLIENTS, values)
}

const infoOneClient = (id, empresa) => {
  return axiosService.get(salesClientsEndpoints.INFO_ONE_CLIENT + '/' + id + '/' + empresa)
}

const clientsBefore = () => {
  return axiosService.get(salesClientsEndpoints.BEFORE)
}

const cuentas = () => {
  return axiosService.get(salesClientsEndpoints.CUENTAS)
}

const deleteClient = (id, empresa) => {
  return axiosService.del(salesClientsEndpoints.DELETE_CLIENT + id + '/' + empresa)
}

const edit = (id, empresa, body) => {
  return axiosService.put(salesClientsEndpoints.EDIT_CLIENT + id + '/' + empresa, body)
}

const changeStatus = (body) => {
  return axiosService.post(salesClientsEndpoints.CHANGE_STATUS, body)
}

const deleteContactInformation = (id, empresa, body) => {
  return axiosService.put(
    salesClientsEndpoints.DELETE_CONTACT_INFORMATION + id + '/' + empresa,
    body
  )
}

const exportDataClients = (body) => {
  return axiosService.post(salesClientsEndpoints.EXPORT_DATA_CLIENTS, body)
}

const printCtaCte = (body) => {
  return axiosService.getPDF(salesClientsEndpoints.PRINT_CTA_CTE, body)
}

const createFollowUpHistory = (clientId, body) => {
  return axiosService.post(
    salesClientsEndpoints.CREATE_FOLLOW_UP_HISTORY + '/' + clientId + '/history/follow-ups',
    body
  )
}

export const salesClients = {
  exportClients,
  exportProviders,
  clientsArca,
  clientsList,
  searchClients,
  searchAutocompleteClients,
  create,
  infoOneClient,
  clientsBefore,
  cuentas,
  deleteClient,
  edit,
  changeStatus,
  deleteContactInformation,
  exportDataClients,
  printCtaCte,
  createFollowUpHistory,
}
